module.exports = __webpack_public_path__ + "img/logo_muensterland.82053faa.png";